jQuery(function ($) {
	wishlistSlider();
	function wishlistSlider() {
				$('#wishlist_slider').flexslider({
					animation: "slide",
					itemWidth: 228,
					itemMargin: 5,
					animationLoop: true, // Infinity Next
					controlNav: false, // hide control navigator if 'false'
					slideshow: false // disable auto play if 'false'
				});
	}
	
	var cookieName = "wishlistList";

	try
	{
		if($j.cookie(cookieName) != null && $j.cookie(cookieName) != '__' && $j.cookie(cookieName) != '') {
			var str = String($j.cookie(cookieName)).split("__");
			for(var i=0; i<str.length; i++) {
				if(str[i] != '') {
					wishListItem(str[i]);
				}
			}
          
          if($j.cookie('heart_button_koki') != null){
             if ($j.cookie('heart_button_koki') == 'true') {
              $('#wishlist_slider').slideDown(300);
              }
              else {
                $('#wishlist_slider').slideUp(300);
              } 
          }

          setTimeout(function(){
              var jbn_shown = $('#wishlist_slider').css('display');
              var jbn_wishlist = '.nj_wishlist_row_label i[nj-trigger]';
              if (jbn_shown == 'none') {
                  $(jbn_wishlist).attr('nj-click', '');
              }
              else {
                  $(jbn_wishlist).attr('nj-click', 'active');
              }
          }, 800);
          
		}
		else
		{
			emptyWishlist();
		}
	}
	catch (err) {
    	console.log(err);
    } // ignore errors reading cookies

	function emptyWishlist() {
		$('.nj_get_wishlist').remove();
		$('.nj_wishlist_empty').show();
		$('.nj_wishlist_row_list_divider').show();
		$('.nj_wishlist_row_list').hide();
        $('.nj_wishlist_row_label').hide();
		
	}
	function wishListItem(prod) {
              jQuery.getJSON('/products/'+prod+'.js', function(product) {
                
			// Page View Start
			var my_img = product.featured_image.replace(/\.jpg/g,'_medium.jpg');
			var my_title = product.title;
			var my_money = Shopify.formatMoney(product.price_min, "${"+"{amount}}");
			var my_url = product.url;
			var my_handle = product.handle;

			var item_img = '<li><a href="'+my_url+'" title="'+my_title+'" alt="'+my_title+'" ><img class="'+my_handle+'" src="'+my_img+'" title="'+my_title+'" alt="'+my_title+'"/></a></li>';
			var item_title = '<li><a href="'+my_url+'" title="'+my_title+'" alt="'+my_title+'" >'+my_title+'</a></li>';
			var item_money = '<li><span>'+my_money+'</span></li>';
			var item_remove = '<li><span class="nj_remove material-icons" nj-handle="'+my_handle+'">delete</span>' +
                				'<div class="davz_prod_icons icon-compare-n"><a href="javascript:void(0);" nj="compare" handle="'+my_handle+'" title="COMPARE PRODUCT">' +
                				'<span class="origin-icon-arrow-compare"></span> </a></div>' +
            					'<a href="javascript:void(0);" onclick="quiqview(\''+my_handle+'\');" class="material-icons">visibility</a></li>';

            var money1 = product.price_min;
            var money2 = product.compare_at_price_min;
			if (money2 == 0) {
              var money = '<span nj-regular-price>'+Shopify.formatMoney(money1, "${"+"{amount}}")+'</span>';
            }
            else {
              var money = '<span nj-new-price>'+Shopify.formatMoney(money1, "${"+"{amount}}")+'</span> <span nj-old-price>'+Shopify.formatMoney(money2, "${"+"{amount}}")+'</span>';
            }
            item_money = '<li><div nj-money>'+money+'</div></li>';   
                
                
          // new product banner
          var date_added = new Date(product.created_at);
          var today = new Date();
          var diff = today - date_added;
          var date_diff = Math.abs((((diff / 60e3)/ 60)/ 24));

          var new_add = '';
          
          if(date_diff < 11){
            new_add = '<div class="new-prod-badge_n"><span>NEW</span></div>';
          } else {
            new_add = '';
          }

          // sale banner
          var sale = '';
          if (product.compare_at_price_min > product.price_min) {
            sale = '<div class="davz-onsale-badge"><span>ON SALE</span></div>';
          } else {
            sale = '';
          }

          //last call
          var lastcall = '';
          var product_tags = product.tags;
          //product_tags = product_tags.toLowerCase();

          if (product_tags.includes('last call') || product_tags.includes('Last Call')) {
            lastcall = '<div class="last-call-badge_n">' +
                      '<img class="img-responsive" src="//cdn.shopify.com/s/files/1/1324/9125/files/haus-lastcall-banner.PNG?14576137295436867839" style="margin: 0 auto;" /></div>'
          } else {
            lastcall = '';
          }
                
                var item_banner = '<div class="prod-badge">'+ new_add + sale + lastcall + '</div>';
         
                
           //Image Variants
          var images = [];
          for (var i = 0; i < product.variants.length; i++) {
              images.push('<li><img src="' + product.variants[i].featured_image.src.replace(/\.jpg/,'_thumb\.jpg') + '" class="'+my_handle+'" title="'+product.variants[i].option1+'" alt="'+product.variants[i].option1+'" /></li>');
          }
          images = '<ul class="slide">' + removeDupsArray(images).join('') + '</ul>';
                
          var varimages = '<div class="jbn_wishlist_view_images"><div class="nj_recently_view_slider"><div class="nj_recently_view_flex">'+
               images+ '</div></div></div>';     
                
                
          //Product Total Color
          var my_total_color = product.options[0].values.length;
          
          if(my_total_color > 1){
          	my_total_color = my_total_color + ' COLORS';
          } else {
          	my_total_color = my_total_color + ' COLOR';
          }    
                
          //Percentage Saved
          var savedperc = ((money2 - money1) / money2)*100;
          if(money2 <= money1){
          	savedperc = '';
          } else {
          	savedperc = '<div class="jbn_total_saved"><span>Save ' +Math.round(savedperc) + '%</span></div>';
          }
          
          var tc_sp = '<div class="njohn_product_grid_color_counts">' + '<span>'+ my_total_color +'</span>' + savedperc + '</div>';   
                
            $('.nj_get_wishlist').append('<ul nj-handle="'+my_handle+'">' + item_remove + item_banner + item_img + varimages + tc_sp + item_title + item_money + "</ul>");
			
			$('.nj_remove').click(function(event) {
				event.preventDefault();
				var my_item_h = $(this).attr("nj-handle");
				var my_item = $(this);
					my_item.parent().parent().fadeOut(500);
				var ck = $j.cookie(cookieName);
					ck = ck.replace(my_item_h, '');
					ck = ck.replace('____', '__');
					$j.cookie(cookieName, ck, {expires:7, path:'/'});
				setTimeout(removeItem, 500, my_item);
				$('.nj_wishlist_header_list tbody[nj-myhandle="' + my_item_h + '"]').fadeOut(500);
			});
			// Page View End
			
			// Header Menu Start
			var my_h_img = product.featured_image.replace(/\.jpg/g,'_small.jpg');
			var my_h_title = product.title;
			var my_h_money = Shopify.formatMoney(product.price_min, "${"+"{amount}}");
			var my_h_url = product.url;
			var my_h_handle = product.handle;

			var item_h_img = '<a href="'+product.url+'"><img src="'+my_h_img+'" title="'+my_h_title+'" alt="'+my_h_title+'"/></a>';
			var item_h_title = '<a href="'+my_h_url+'" title="'+my_h_title+'" alt="'+my_h_title+'" >'+my_h_title+'</a>';
			var item_h_money = my_h_money;
			var item_h_rm = 'nj-remove' + ' nj-handle="' + my_h_handle + '"';
			var item_h_handle = 'nj-myhandle="' + my_h_handle + '"';
			var item_h_vw = 'nj-view' + " onclick=\"quiqview('" + my_h_handle + "');\"";

          
			$('#wishlist_slider').data('flexslider').addSlide('<li '+item_h_handle+' nj-item>' +
													 	'<div>' +
													 		'<span '+item_h_rm+' class="material-icons">delete</span>' +
													 		'<span '+item_h_vw+' class="material-icons">visibility</span>' +
													 	'</div>' +
													 	'<div>'+item_h_img+'</div>' +
														'<div>'+item_h_title+'</div>' +
													 	'<div>' +
													 		'<span>'+item_h_money+'</span>' +
													 	'</div>' +
													 '</li>');
          
			// Header Menu End
          
		$('.nj_wishlist_row_list').show();
        $('.nj_wishlist_row_label').show();
		$('.nj_wishlist_row_list_divider').hide();
		countWishlist();
          });
	}
	
	function removeItem(my_item) {
		if($j.cookie(cookieName) == '__' || $j.cookie(cookieName) == '') {
			emptyWishlist();
		}
	}
	function countWishlist() {
		var count = $('.nj_wishlist_row_list li[nj-myhandle]').length;
    	$('.nj_wishlist_row_label span[nj-count], .nj_menu_wishlist span[nj-count], .davz_new_account_icon span[nj-count]').text( count );
      if(count == '' || count == 0) {
    	$('.nj_wishlist_row_label span[nj-count], .nj_menu_wishlist span[nj-count]').text('0');
        $('.nj_menu_wishlist i').attr('nj-click', '');
        $('.nj_wishlist_row_label').hide();
      }
      else {
    	$('.nj_wishlist_row_label span[nj-count], .nj_menu_wishlist span[nj-count]').text("" + count + "");
      }
	}
	
    $(document).on("click", '.add-in-wishlist-js', function(event) { 
		var handle = $(this).attr('my-handle');
			
//         setTimeout(function(){
// 			wishListItem(handle);
//         }, 2000);
 			wishListItem(handle);
	});

    $(document).on("click", '.nj_wishlist_row_list span[nj-remove]', function(event) { 
		var handle = $(this).attr('nj-handle');
        $('.defbtn' + handle).show();
        $('.defbtn' + handle + ' + .added-wishbutton').hide();
		var index = $('.nj_wishlist_row_list li[nj-myhandle="' + handle + '"]').index();
      console.log(index);
		$('#wishlist_slider').data('flexslider').removeSlide(index);
				var ck = $j.cookie(cookieName);
					ck = ck.replace(handle, '');
					ck = ck.replace('____', '__');
					$j.cookie(cookieName, ck, {expires:7, path:'/'});
				setTimeout(removeItem, 500, handle);
		countWishlist();
	});
    $(document).on("click", '.nj_wishlist_row_label i[nj-trigger]', function(event) { 
			var click = $(this).attr('nj-click');
			if(click == '') {
				$(this).attr('nj-click', 'active');
				$('#wishlist_slider').slideDown(300);
                heart_button_koki(true);
			}
			else {
				$(this).attr('nj-click', '');
				$('#wishlist_slider').slideUp(300);
                heart_button_koki(false);
			}
	});
  
  
    function heart_button_koki(d) {
      var koki = 'heart_button_koki';
      if(d) {
       $j.cookie(koki, 'true', { path: '/' });
      }
      else {
       $j.cookie(koki, 'false', { path: '/' });
      }
    }
  
    $(document).on("mouseover", '.jbn_wishlist_view_images ul li img', function (event) {
    	var thisis = $(this).attr("class");
    	//$(".nj_products_comparison_table tr td[class='"+getclass+"']").remove();
		var hoverimg =  $(this).attr('src');
    	$('.nj_get_wishlist a img.' + thisis).attr("src",ThumbtoLargeImage(hoverimg));
	});
      
  	function ThumbtoLargeImage(img) {
		img = img.replace(/\_thumb.jpg/g,'_large.jpg');//_small
		img = img.replace(/\_thumb.jpeg/g,'_large.jpeg');//_small
      	return img;
	}
  
  	function removeDupsArray(data) {
		return data.filter(function(nj,i,data){
			return i == data.indexOf(nj);
		});
	}
  
   $(document).on("click", '.nj_remove', function(event) {
          var handle = $(this).attr('nj-handle');
          var index = $('.nj_wishlist_row_list li[nj-myhandle="' + handle + '"]').index();
          $('#wishlist_slider').data('flexslider').removeSlide(index);
          countWishlist();

      });
	
});